<template>
    <canvas ref="canvas" class="canvas" width="800" height="500"></canvas>
</template>

<script>
    export default {
        name: 'PieChart',

        props: {
            myData: {
                type: Array,
                default: []
            },
            myLabel: {
                type: Array,
                default: []
            }
        },

        methods: {

            getTotal(){
                var myTotal = 0;
                for (var j = 0; j < this.myData.length; j++) {
                    myTotal += (typeof this.myData[j] == 'number') ? this.myData[j] : 0;
                }
                return myTotal;
            },

            plotData() {
                var lastend = 0;
                var myTotal = this.getTotal();
                const canvas = this.$refs.canvas; 
                var x = (canvas.width)/2;
                var y = (canvas.height)/2;
                var r = 150;

                const myColor = [
                    "#ffc059",
                    "#ff6565",
                    "#708bcc",
                    "#4ad991",
                    "#52dfec",
                    "#a3a0fb"
                ];
                
                const ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                for (var i = 0; i < this.myData.length; i++) {
                    ctx.fillStyle = myColor[i];
                    ctx.beginPath();
                    ctx.moveTo(x,y);
                    ctx.arc(x,y,r,lastend,lastend+(Math.PI*2*(this.myData[i]/myTotal)),false); 
                    ctx.lineTo(x,y);
                    ctx.fill();
                    
                    // Now the pointers
                    ctx.beginPath();
                    var start = [];
                    var end = [];
                    var last = 0;
                    var flip = 0;
                    var textOffset = 0;
                    var precentage = (this.myData[i]/myTotal)*100;
                    start = this.getPoint(x,y,r-20,(lastend+(Math.PI*2*(this.myData[i]/myTotal))/2));
                    end = this.getPoint(x,y,r+20,(lastend+(Math.PI*2*(this.myData[i]/myTotal))/2));
                    if(start[0] <= x)
                    {
                        flip = -1;
                        textOffset = -160;
                    }
                    else
                    {
                        flip = 1;
                        textOffset = 0;
                    }
                    ctx.moveTo(start[0],start[1]);
                    ctx.lineTo(end[0],end[1]);
                    ctx.lineTo(end[0]+120*flip,end[1]);
                    ctx.strokeStyle = "#bdc3c7";
                    ctx.fillStyle = "#000000";
                    ctx.lineWidth   = 2;
                    ctx.stroke();
                    // The labels
                    ctx.font="16px Arial";

                    const title = this.myLabel[i].split(' ')
                    if(!title[1]){
                        ctx.fillText(title[0]+" "+precentage.toFixed(2)+"%",end[0]+textOffset,end[1]-4); 
                    }else{
                        ctx.fillText(title[0], end[0]+textOffset, end[1]-25);
                        ctx.fillText(title[1]+" "+precentage.toFixed(2)+"%",end[0]+textOffset,end[1]-4);
                    }
                    
                    // Increment Loop
                    lastend += Math.PI*2*(this.myData[i]/myTotal);
                    
                }
            },
            
            getPoint(c1,c2,radius,angle) {
                return [c1+Math.cos(angle)*radius,c2+Math.sin(angle)*radius];
            }
        },

        mounted () {
            this.plotData();
        },

        computed: {
            chart(){
                return this.$refs.canvas;
            }
        },

        watch: {
            myData() {
                this.plotData()
            },
            myLabel() {
                this.plotData()
            }
        }
    }
</script>

<style lang="scss" scoped>
.canvas{
    max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/canvas-chart/PieChart.vue